import { render, staticRenderFns } from "./EnduranceParamsView.vue?vue&type=template&id=826cdcf0"
import script from "./EnduranceParamsView.vue?vue&type=script&lang=js"
export * from "./EnduranceParamsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports